import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';
import versions from './manifest.json';
import { reactI18nextModule } from 'react-i18next';
import { SITES } from 'lib/constants';

const SITE_DEFAULT = 'com';
const SITE_LOCALE = Object.keys(SITES).reduce(
  (acc, key) => ({ ...acc, [SITES[key].code]: SITES[key].defaultLocale }),
  { debug: 'debug' },
);

const SITE_WHITELIST = Object.keys(SITE_LOCALE);
//
// TODO: previous cache solutons was depricated
// we should explore using LocalStorageBackend
// together with chained backend.
//
// import i18next from 'i18next';
// import Backend from 'i18next-chained-backend';
// import LocalStorageBackend from 'i18next-localstorage-backend'; // primary use cache
// import XHR from 'i18next-xhr-backend'; // fallback xhr load
//

export const rule = {
  numbers: [0, 1, 2],
  plurals: num => Number(num >= 2 ? 2 : num),
};

i18n.on('initialized', options => {
  Object.entries(SITE_LOCALE).map(([locale, val]) =>
    i18n.services.pluralResolver.addRule(locale, rule),
  );
});

const { ajax } = new XHR().options;
function loadLocales(site, ...other) {
  const file =
    versions[SITE_LOCALE[site]] || versions[SITE_LOCALE[SITE_DEFAULT]];
  // eslint-disable-next-line no-undef
  const url = `${file}`;
  return ajax(url, ...other);
}

i18n
  .use(LngDetector)
  .use(XHR)
  .use(reactI18nextModule)
  .init({
    interpolation: {
      prefix: '%{',
      suffix: '}',
    },
    load: 'languageOnly',
    debug: false,
    fallbackLng: SITE_DEFAULT,
    backend: {
      loadPath: '%{lng}',
      ajax: loadLocales,
    },
    preload: [SITE_DEFAULT],
    whitelist: SITE_WHITELIST,
    detection: {
      order: ['querystring', 'cookie', 'path'],
    },
    react: {
      wait: true,
    },
  });

export default i18n;
